var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-6 md:flex"},[_c('inv-strat-diversifications',{on:{"backStep":function($event){return _vm.handleBackStep()},"nextStep":function($event){return _vm.handleNextStep()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }